<div class="dynamic-page">
    <section class="dynamic-hero animate-fade-in-up" aria-label="Introduction">
        <div class="dynamic-hero__container">
            <div class="dynamic-hero__title">
                Support, <span>Re-engineered.</span><br />
                Driven by Intelligence.
            </div>
            <div class="dynamic-hero__copy">
                Eliminate operational bloat. We replace reactive, labor-intensive support layers with a bespoke,
                AI-autonomous architecture—driving radical cost reduction and structural efficiency for Microsoft
                Dynamics 365.
            </div>
            <div class="dynamic-hero__actions">
                <button type="button" class="dynamic-btn dynamic-btn--solid" (click)="openCalendlyPopup()">Initiate Systems Audit</button>
            </div>
        </div>
    </section>

    <section class="methodology" aria-label="AI Support Framework">
        <div class="methodology__container">
            <div class="methodology__head">
                <div class="methodology__eyebrow">The Methodology</div>
                <div class="methodology__title">
                    Overcoming the Operational Drag of legacy application management.
                </div>
            </div>

            <div class="methodology__grid">
                <div class="methodology__left">
                    <div class="methodology__label">01. The Bottleneck</div>
                    <div class="methodology__items">
                        <article>
                            <div class="methodology__item-title">Ticket Inflation</div>
                            <div class="methodology__item-copy">
                                As user bases expand, organizations face an exponential influx of low-value, repetitive
                                inquiries. This inflates raw operational costs and buries high-tier engineers doing
                                rudimentary data-entry tasks.
                            </div>
                        </article>
                        <article>
                            <div class="methodology__item-title">Triage Friction</div>
                            <div class="methodology__item-copy">
                                Manual categorization, routing, and investigation consume upwards of 20 minutes per
                                incident—a massive, hidden systemic tax levied before resolution even begins.
                            </div>
                        </article>
                    </div>
                </div>

                <div class="methodology__right">
                    <div class="methodology__right-graphic" aria-hidden="true">
                        <svg viewBox="0 0 100 100" fill="none" stroke="#fff" stroke-width="0.2">
                            <circle cx="50" cy="50" r="40"></circle>
                            <circle cx="50" cy="50" r="30"></circle>
                            <circle cx="50" cy="50" r="20"></circle>
                            <path d="M10 50h80M50 10v80M20 20l60 60M20 80l60-60"></path>
                        </svg>
                    </div>
                    <div class="methodology__right-content">
                        <div class="methodology__right-head">
                            <span>02. The Architecture</span>
                            <span>v2.0 Framework</span>
                        </div>
                        <div class="methodology__vector-items">
                            <article>
                                <div class="methodology__vector-row">
                                    <div class="methodology__vector-title">L0 Autonomous <br />Copilot Agent</div>
                                    <div class="methodology__vector-value">45%</div>
                                </div>
                                <div class="methodology__vector-copy">
                                    Zero-touch resolution capability. The L0 agent intercepts high-volume requests,
                                    directly interfacing with Microsoft Dynamics 365 data structures to automate and
                                    execute the resolution immediately.
                                </div>
                            </article>
                            <article>
                                <div class="methodology__vector-row">
                                    <div class="methodology__vector-title">L1 Augmented <br />Engineering</div>
                                    <div class="methodology__vector-value">35%</div>
                                </div>
                                <div class="methodology__vector-copy">
                                    AI-powered topographical surfacing. The system instantly delivers ticket
                                    similarities, deep knowledge vectors, and pre-compiled resolution scripts directly
                                    to human engineers, drastically speeding up human intervention.
                                </div>
                            </article>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- <section id="contact" class="contact-section" aria-label="Contact Us">
        <div class="contact-section__container">
            <div class="contact-section__grid">
                <div>
                    <div class="contact-section__eyebrow">Connect</div>
                    <div class="contact-section__title">Discover the future of applied AI.</div>
                    <div class="contact-section__copy">
                        Connect with our delivery experts to audit your topology and map your enterprise integration
                        roadmap.
                    </div>
                </div>

                <div class="contact-card">
                    <div class="contact-card__corner" aria-hidden="true"></div>
                    <div class="contact-card__title">Direct Inquiry</div>

                    <div *ngIf="submitted" role="alert" class="contact-card__success animate-fade-in-up">
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        <div>Request securely logged. Our architecture team will reach out within one business day.
                        </div>
                    </div>

                    <form *ngIf="!submitted" [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form">
                        <div class="contact-form__field">
                            <input type="text" formControlName="name" placeholder="Full Name" />
                        </div>

                        <div class="contact-form__row">
                            <div class="contact-form__field">
                                <input type="email" formControlName="email" placeholder="Corporate Email" />
                            </div>
                            <div class="contact-form__field">
                                <input type="text" formControlName="company" placeholder="Organization" />
                            </div>
                        </div>

                        <div class="contact-form__field">
                            <textarea rows="3" formControlName="message"
                                placeholder="Brief context of operational challenges..."></textarea>
                        </div>

                        <button type="submit" [disabled]="contactForm.invalid || isSubmitting"
                            class="contact-form__submit">
                            <span *ngIf="!isSubmitting">Transmit Request</span>
                            <span *ngIf="isSubmitting" class="contact-form__submit-loading">
                                <svg viewBox="0 0 24 24" aria-hidden="true">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <path d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                                </svg>
                                Encrypting...
                            </span>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </section> -->
</div>
